const imp = () => import(/* webpackChunkName: "loadSprite_message_module_color"*/  "../sprite/loadSprite_message_module_color");
const loadMap_message_module_color: { [key: string]: () => Promise<any> } = {
  "Icon-Account-Manager": imp,
  "Icon-Audio-files": imp,
  "Icon-Compressed-file": imp,
  "Icon-Excel-file": imp,
  "Icon-Group-leader": imp,
  "Icon-Installation-package-file": imp,
  "Icon-HTML-file": imp,
  "Icon-PPT-file": imp,
  "Icon-Ofd-file": imp,
  "Icon-Pdf-file": imp,
  "Icon-Picture-file": imp,
  "Icon-Txt-file": imp,
  "Icon-Unknown-file": imp,
  "Icon-Unread-fixed-color": imp,
  "Icon-administrators": imp,
  "Icon-Word-file": imp,
  "Icon-customer-color": imp,
  "Icon-video-file": imp,
  "Icon-Mac-online-blue": imp,
  "Icon-Mobile-web-online-blue": imp,
  "Icon-Android-fixed-color": imp,
  "Icon-PC-online-blue": imp,
  "Icon-Push-fixed-color": imp,
  "Icon-Apple-fixed-color": imp,
  "Icon-Apple-iPad-Online": imp,
  "Icon-Tablet-Online": imp,
  "Icon-Web-online-blue": imp,
  "Icon-off-line": imp,
  "Icon-leave": imp,
  "Icon-apk": imp,
  "Icon-emojilike": imp,
  "Icon-Defaultemoji": imp,
  "Icon-apk02": imp,
  "Icon-Groupleader2": imp,
  "Icon-withinrules": imp,
  "Icon-administrators2": imp,
  "Icon-topic-of-conversation-blue": imp,
  "Icon-normaltop": imp,
  "Icon-Forcetop": imp,
}
export default loadMap_message_module_color;